module.exports = __webpack_public_path__ + "img/banner2.06551dfb.png";